declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../../../models/api_request_model';
import { SpinnerService } from '../../../../../../services/spinner.service';
import { AppData } from '../../../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest } from '../../../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../services/hcp.service';


import * as alertFunctions from '../../../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SavePatientInfoRequest, PatientInfoByFormattedCodeController, UpdatePatientInfoRequest, SaveVendorInfoRequest, SaveMaterialDetailsInfoRequest, MaterialsListController, MaterialsListRequest, SaveMaterialToStoreInfoRequest, SaveNewServiceRequest, GenericProcPostRequest, S_Methods, GenericParams, FTV } from '../../../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../../../models/actor/actor';
import { ActorService } from '../../../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../../../models/master/mastermodel';
import { FDService } from '../../../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgbSearchProviderModal } from '../../../../ivf/ivfworkbench/searchprovider.modal';
import { NgbSearchPatientModal } from '../../../../follow up/counsellingregistry/modal/searchpatient.modal';
import { NgbCameraUploadModal } from './cameraupload.modal';

@Component({
  selector: 'ngberpsetup',
    templateUrl: './erpsetup.modal.html',
    styleUrls: ['./erpsetup.modal.scss']
})

export class NgbErpSetupModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;

  @Input() IsShowDetail: boolean = false;

  // @Input() CurrentSavePatientInfoRequest: SavePatientInfoRequest;
    @Input() CurrentSavePatientInfoRequest: UpdatePatientInfoRequest;
    CurrentSaveVendorInfoRequest: SaveVendorInfoRequest;
    CurrentSaveMaterialDetailsInfoRequest: SaveMaterialDetailsInfoRequest;
    CurrentSaveMaterialToStoreInfoRequest: SaveMaterialToStoreInfoRequest;
  @Input() ServiceCode: number;
  searchTitle: string;
  public ApiResData: ApiResponseModel;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  DOB: NgbDateStruct;
  WeddingDate: NgbDateStruct;
  RegistrationVal: NgbDateStruct;
  VaildFrom: NgbDateStruct;
    ValidTo: NgbDateStruct;
    
  public SelectedSource: string;
  public ProviderName: string;
  public ProviderCode: number;
    public ProviderNumber: string;
    public searchValue: string;
  public PrimaryDoctor: string;
  public PrimaryCode: number;
  public PrimaryNumber: number;
  public ProviderName1: string;
  public ProviderCode1: number;
  public ProviderNumber1: string;
  public PatientName: string;
    public PatientActorCode: number;
    public isvisiblev: boolean = true;
    public isvisiblem: boolean = true;
    public isvisiblemts: boolean = true;
  public PatientNumber: string;
    public StaffName: string;
    public Institute: string;
    public ActorCode2: number;
    public FacilityCode: number;
    public StaffCode: number;
    MfgDate: NgbDateStruct;
    ExpDate: NgbDateStruct;
  public StaffNumber: string;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  public PrimaryDoctorO: boolean = true;
  public PrimaryDoctorn: boolean = false;
    Todate = new Date();
    TodayDate = new Date();
  //public IsSelected: boolean;
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private modalService: NgbModal, private hcpservice: HCPService, private parserFormatter: NgbDateParserFormatter,
    private tosterservice: NGXToastrService) { }
  ngOnInit() {
      this.StoreItems();
    this.ShowService = false;
    //alert(this.CurrentSavePatientInfoRequest.PrimaryDoctor);
      //this.minDate = { year: 1900, month: 1, day: 1 };
      //this.maxDate = { year: this.Todate.getFullYear(), month: 1, day: 1 };
    //this.LoadRegistries();
      //alert(this.CurrentSavePatientInfoRequest.DateOfBirth);
      this.CurrentSaveVendorInfoRequest = new SaveVendorInfoRequest();
      this.CurrentSaveVendorInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveMaterialDetailsInfoRequest = new SaveMaterialDetailsInfoRequest();
      this.CurrentSaveMaterialDetailsInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveMaterialToStoreInfoRequest = new SaveMaterialToStoreInfoRequest();
      this.CurrentSaveMaterialToStoreInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.FacilityCode = AppData.Instance().SelectedBranchCode;
      this.ActorCode2 = AppData.Instance().UserLoginDetails.ActorCode;
      this.MfgDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.ExpDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.CurrentSaveNewServiceRequest = new SaveNewServiceRequest();
    this.CurrentSaveNewServiceRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }

  AddMedToGeneric(med: string) {
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    var saveReq: GenericParams = new GenericParams();
    saveReq.ConditionalOperator = 60111;
    saveReq.Params = [
      new FTV('MedName', 'string', med)
    ];
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 60111;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            //this.LoadAdmissionServices();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  //BranchMapData: ServiceBranchMapByServiceCodeController[];
  //BranchMapRequest: ServiceBranchMapByServiceCodeRequest;
  //this.pdata = this.CurrentCustomCodeValuesController;
  
  //General() {

  //}
    CurrentMaterialsListRequest: MaterialsListRequest;
    CurrentMaterialsListController: MaterialsListController[];
    StoreItems() {
        // alert()
        this.CurrentMaterialsListRequest = new MaterialsListRequest();
        //this.pdata2 = this.ServicesByCategoryCodeController;

        this.CurrentMaterialsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentMaterialsListRequest.ConditionalOperator = 10;
        this.CurrentMaterialsListRequest.MaterialCode = 0;
        //this.pdata = this.CurrentStoreLocationMaterialsController;

        this.GetMaterialsListController();

    }
    RefreshPatients(st: string) {
        this.CurrentMaterialsListRequest = new MaterialsListRequest();
        this.CurrentMaterialsListRequest.ConditionalOperator = 20; 
        this.CurrentMaterialsListRequest.SearchText = st;
        this.CurrentMaterialsListRequest.MaterialCode = 0;
        this.CurrentMaterialsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetMaterialsListController();
    }

    GetMaterialsListController() {
        this.StartRefreshing();
        //this.spinner.show();
        this.actorservice.GetMaterialsListController(this.CurrentMaterialsListRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                //alert(this.ApiResData.ErrorData);
                if (!this.ApiResData.hasError) {

                    this.CurrentMaterialsListController = this.ApiResData.Result;
                    //this.pdata = this.CurrentStoreLocationMaterialsController;
                    //this.spinner.hide();
                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );

    }
    SelectedMaterialDetails: MaterialsListController;
    SelectedMaterial(objCategory: any) {
        var Patient: MaterialsListController = objCategory;
        if (Patient != null) {
            this.SelectedMaterialDetails = null;
            this.SelectedMaterialDetails = Patient;
            //this.ScanDetails = true;
            //this.LoadCycles();
            //this.LoadScansData();
            //this.LoadOvaryData();
            //this.LoadTestData();
            //this.LoadMedicineData();
            //this.LoadLmp()
            //this.LoadCycleActivities = true;
            //this.CanLoadReport = true;
            //this.ngOnChanges2(this.changes);
        }

    }

    General() {
        this.isvisiblev = false;
        this.CurrentSaveVendorInfoRequest.ConditionalOperator = 10;
   // this.CurrentSavePatientInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DOB));

        this.actorservice.SaveVendorInfo(this.CurrentSaveVendorInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

              this.ClearAllVendor();
              this.isvisiblev = true;
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
           
              this.isvisiblev = true;
            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
              this.isvisiblev = true;


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
              this.isvisiblev = true;
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
              this.isvisiblev = true;
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
              this.isvisiblev = true;
            this.stopRefreshing();
          }
        }
      );

    }
    ClearAllVendor() {
        //this.CurrentSaveVendorInfoRequest = new SaveVendorInfoRequest();
        //this.CurrentSaveVendorInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentSaveVendorInfoRequest.VendorName = "";
        this.CurrentSaveVendorInfoRequest.ContactNo = "";
        this.CurrentSaveVendorInfoRequest.Location = "";
    }
    Education() {
        this.isvisiblem = false;
        this.CurrentSaveMaterialDetailsInfoRequest.ConditionalOperator = 10;
        this.CurrentSaveMaterialDetailsInfoRequest.MaterialGroupCode = this.MaterialGroupCode;

        this.actorservice.SaveMaterialDetailsInfo(this.CurrentSaveMaterialDetailsInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

              this.ClearAllMaterial();
              this.isvisiblem = true;
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
              //this.activeModal.close();
              this.isvisiblem = true;
            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
              //this.activeModal.close();
              this.isvisiblem = true;
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
              //this.activeModal.close();
              this.isvisiblem = true;
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
              //this.activeModal.close();
              this.isvisiblem = true;
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
              //this.activeModal.close();
              this.isvisiblem = true;
            this.stopRefreshing();
          }
        }
      );

    }
    ClearAllMaterial() {
        this.CurrentSaveMaterialDetailsInfoRequest.HsnCode = null;
        this.CurrentSaveMaterialDetailsInfoRequest.MaterialName = null;
        this.CurrentSaveMaterialDetailsInfoRequest.PurchaseUnit = null;
        this.CurrentSaveMaterialDetailsInfoRequest.SellingUnit = null;
        this.CurrentSaveMaterialDetailsInfoRequest.TaxPercentage = null;
        this.CurrentSaveMaterialDetailsInfoRequest.MaterialGroupCode = null;
    }
    Registration() {
        this.isvisiblemts = false;
        this.CurrentSaveMaterialToStoreInfoRequest.ConditionalOperator = 10;
        this.CurrentSaveMaterialToStoreInfoRequest.SupplierCode = this.SupplierCode;
        this.CurrentSaveMaterialToStoreInfoRequest.SupplierName = this.SupplierName;
        this.CurrentSaveMaterialToStoreInfoRequest.ManufacturingDate = new Date(this.parserFormatter.format(this.MfgDate));
        this.CurrentSaveMaterialToStoreInfoRequest.ExpiryDate = new Date(this.parserFormatter.format(this.ExpDate));
        this.CurrentSaveMaterialToStoreInfoRequest.MaterialStoreName = this.StoreName;
        this.CurrentSaveMaterialToStoreInfoRequest.MaterialStoreCode = this.StoreCode;
        this.CurrentSaveMaterialToStoreInfoRequest.MaterialCode = this.SelectedMaterialDetails.MaterialCode;
        //this.CurrentSavePatientInfoRequest.WeddingAnniversary = new Date(this.parserFormatter.format(this.WeddingDate));
        this.actorservice.SaveMaterialToStoreInfo(this.CurrentSaveMaterialToStoreInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;

              this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
              this.ClearAllMaterialtostrore();
              //this.activeModal.close();
              this.isvisiblemts = true;
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
              //this.activeModal.close();
              this.isvisiblemts = true;
            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
              // this.activeModal.close();
              this.isvisiblemts = true;

          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
              //this.activeModal.close();
              this.isvisiblemts = true;
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
              //this.activeModal.close();
              this.isvisiblemts = true;
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
              //this.activeModal.close();
              this.isvisiblemts = true;
            this.stopRefreshing();
          }
        }
      );

    }
    ClearAllMaterialtostrore() {
        this.CurrentSaveMaterialToStoreInfoRequest.BatchNo = null;
        this.CurrentSaveMaterialToStoreInfoRequest.GST = null;
        this.CurrentSaveMaterialToStoreInfoRequest.MaterialStoreName = null;
        this.CurrentSaveMaterialToStoreInfoRequest.PurchasingPrice = null;
        this.CurrentSaveMaterialToStoreInfoRequest.SellingPrice = null;
        this.CurrentSaveMaterialToStoreInfoRequest.StockInUnits = null;
        this.CurrentSaveMaterialToStoreInfoRequest.SupplierName = null;
        this.CurrentSaveMaterialToStoreInfoRequest.MaterialStoreCode = null;
        this.CurrentSaveMaterialToStoreInfoRequest.SupplierCode = null;
    }
  Referral() {
    this.StartRefreshing();
    if (this.SelectedSource == "DOC") {
      this.CurrentSavePatientInfoRequest.RefCode = this.ProviderCode;
      this.CurrentSavePatientInfoRequest.RefDetails = this.ProviderName;
      this.CurrentSavePatientInfoRequest.RefContactNo = this.ProviderNumber;
    }
    else if (this.SelectedSource == "DOCEX") {
      //  this.CurrentSavePatientInfoRequest.RefCode = this.ProviderCode1;
      //this.CurrentSavePatientInfoRequest.RefDetails = this.ProviderName1;
      //  this.CurrentSavePatientInfoRequest.RefContactNo = this.ProviderNumber1;
        if (this.CurrentSavePatientInfoRequest.RefCode == null) {
            this.CurrentSavePatientInfoRequest.RefCode = -1;
        }

    }
    else if (this.SelectedSource == "RGPT") {
      this.CurrentSavePatientInfoRequest.RefCode = this.PatientActorCode;
      this.CurrentSavePatientInfoRequest.RefDetails = this.PatientName;
      this.CurrentSavePatientInfoRequest.RefContactNo = this.PatientNumber;
    }
    else if (this.SelectedSource == "STAFF") {
      this.CurrentSavePatientInfoRequest.RefCode = this.StaffCode;
      this.CurrentSavePatientInfoRequest.RefDetails = this.StaffName;
      this.CurrentSavePatientInfoRequest.RefContactNo = this.StaffNumber;
    }
    else if (this.SelectedSource !== "DOC" || "DOCEX" || "RGPT" || "STAFF") {
      this.CurrentSavePatientInfoRequest.RefCode = 0;

    }

    this.CurrentSavePatientInfoRequest.ConditionalOperator = 35;
    this.actorservice.UpdatePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }
  Adress() {
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 42;
    this.actorservice.UpdatePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }
  Contact() {
    this.CurrentSavePatientInfoRequest.ConditionalOperator = 49;
    this.actorservice.UpdatePatientInfo(this.CurrentSavePatientInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            this.ShowService = false;

            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

            this.activeModal.close();

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.activeModal.close();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            this.activeModal.close();


          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            this.activeModal.close();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.activeModal.close();
            this.stopRefreshing();
          }
        }
      );

  }
  CurrentSaveNewServiceRequest = new SaveNewServiceRequest();
  //public ServiceName: string;
  //public RevenueCategoryCode: number;
  //public Price: number;
  //public IsPriceEditable: boolean;
  //public ServiceType: string;
  AddService() {
    var saveReq = new SaveNewServiceRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 30050;
    saveReq.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.ServiceName = this.CurrentSaveNewServiceRequest.ServiceName;
    saveReq.RevenueCategoryCode = this.CurrentSaveNewServiceRequest.RevenueCategoryCode;
    saveReq.Price = this.CurrentSaveNewServiceRequest.Price;
    saveReq.IsPriceEditable = this.CurrentSaveNewServiceRequest.IsPriceEditable;
    saveReq.DepartmentCode = this.CurrentSaveNewServiceRequest.DepartmentCode;
    saveReq.ServiceCategoryCode = this.CurrentSaveNewServiceRequest.ServiceCategoryCode;
    saveReq.ServiceType = this.CurrentSaveNewServiceRequest.ServiceType;
    saveReq.ServicePoint = this.CurrentSaveNewServiceRequest.ServicePoint;
    //if (e.target.checked) {
    //  saveReq.IsPriceEditable = true;
    //}
    //else if (!e.target.checked) {
    //  saveReq.IsPriceEditable = false;
    //}
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 30050;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
    MaterialGroupCode: number = 0;
    public MaterialGroupName: string;
    onAssignedToActorCodesurgeon2(event: any) {

        if (event != null) {
            this.MaterialGroupName = event;
            //this.StoreItems();
            /// this.GroupItems();
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            /// this.CurrentSaveFollicularScanDetailRequest.Sign1 = event;
            // this.CurrentSaveFollicularScanDetailRequest.Sign1Actor = event;
            // console.log('event--_>' + event);
            //   }
        }

    }
    StoreCode: number = 0;
    public StoreName: string;
    onAssignedStores(event: any) {

        if (event != null) {
            this.StoreName = event;
            this.StoreItems();
            /// this.GroupItems();
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            /// this.CurrentSaveFollicularScanDetailRequest.Sign1 = event;
            // this.CurrentSaveFollicularScanDetailRequest.Sign1Actor = event;
            // console.log('event--_>' + event);
            //   }
        }

    }
    SupplierCode: number = 0;
    public SupplierName: string;
    onAssignedVendors(event: any) {

        if (event != null) {
            this.SupplierName = event;
            //this.StoreItems();
            /// this.GroupItems();
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            /// this.CurrentSaveFollicularScanDetailRequest.Sign1 = event;
            // this.CurrentSaveFollicularScanDetailRequest.Sign1Actor = event;
            // console.log('event--_>' + event);
            //   }
        }

    }
  public SelectedFacilityCode: number;
  SelectedFacilityName: string;
  Branchdata(event: any) {

    if (event != null) {
      this.SelectedFacilityName = event;
    }

  }
  public ServiceCategoryCode: number;
  ServiceCategoryName: string;
  ServiceCategory(event: any) {

    if (event != null) {
      this.ServiceCategoryName = event;
    }

  }
  public DepartmentCode: number;
  DepartmentName: string;
  Department(event: any) {

    if (event != null) {
      this.DepartmentName = event;
    }

  }
  //onSubmit() {

  //  this.StartRefreshing();
  //  if (this.SelectedSource == "DOC") {
  //    this.CurrentSavePatientInfoRequest.ReferalDetailCode = this.ProviderCode;
  //    this.CurrentSavePatientInfoRequest.RefDetails = this.ProviderName;
  //    this.CurrentSavePatientInfoRequest.RefContactNo = this.ProviderNumber;
  //  }
  //  else if (this.SelectedSource == "DOCEX") {
  //    this.CurrentSavePatientInfoRequest.ReferalDetailCode = this.ProviderCode1;
  //    this.CurrentSavePatientInfoRequest.RefDetails = this.ProviderName1;
  //    this.CurrentSavePatientInfoRequest.RefContactNo = this.ProviderNumber1;

  //  }
  //  else if (this.SelectedSource == "RGPT") {
  //    this.CurrentSavePatientInfoRequest.ReferalDetailCode = this.PatientActorCode;
  //    this.CurrentSavePatientInfoRequest.RefDetails = this.PatientName;
  //    this.CurrentSavePatientInfoRequest.RefContactNo = this.PatientNumber;
  //  }
  //  else if (this.SelectedSource == "STAFF") {
  //    this.CurrentSavePatientInfoRequest.ReferalDetailCode = this.StaffCode;
  //    this.CurrentSavePatientInfoRequest.RefDetails = this.StaffName;
  //    this.CurrentSavePatientInfoRequest.RefContactNo = this.StaffNumber;
  //  }
  //  else if (this.SelectedSource !== "DOC" || "DOCEX" || "RGPT" || "STAFF") {
  //    this.CurrentSavePatientInfoRequest.ReferalDetailCode = 0;

  //  }    
  //  this.CurrentSavePatientInfoRequest.DateOfBirth = new Date(this.parserFormatter.format(this.DOB));
  //  this.CurrentSavePatientInfoRequest.WeddingAnniversary = new Date(this.parserFormatter.format(this.WeddingDate));
  //  this.CurrentSavePatientInfoRequest.RegistrationValidity = new Date(this.parserFormatter.format(this.RegistrationVal));
  //  this.CurrentSavePatientInfoRequest.ValidFrom = new Date(this.parserFormatter.format(this.VaildFrom));
  //  this.CurrentSavePatientInfoRequest.ValidTo = new Date(this.parserFormatter.format(this.ValidTo));
  //  this.actorservice.SavePatientInfo(this.CurrentSavePatientInfoRequest)
  //    .subscribe((result) => {
  //      this.ApiResData = result;
  //      if (!this.ApiResData.hasError) {

  //        if (this.ApiResData.Result > 0) {
  //          this.ShowService = false;            
  //          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

  //          this.activeModal.close();

  //          this.stopRefreshing();
  //        }
  //        else {
  //          alertFunctions.AlertParam("Invalid Operation...!");
  //          this.activeModal.close();

  //          this.stopRefreshing();

  //        }

  //      }
  //      else {
  //        this.stopRefreshing();
  //        if (this.ApiResData.ErrorData != "") {

  //          alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
  //          this.activeModal.close();


  //        }
  //        else {
  //          alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
  //          this.activeModal.close();
  //        }
  //      }

  //    },


  //      (error) => {

  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.activeModal.close();
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.activeModal.close();
  //          this.stopRefreshing();
  //        }
  //      }
  //    );

  //}




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
  onChange2(event: any) {
    this.SelectedSource = event;
    // alert(this.SelectedSource)

  }
  SelectInternalDoctor() {
    const modalRef = this.modalService.open(NgbSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
      modalRef.componentInstance.IsShowDoctor = true;
      modalRef.componentInstance.DoctorType = this.SelectedSource;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.ProviderName = receivedEntry.make;
      this.ProviderCode = receivedEntry.value;
      this.ProviderNumber = receivedEntry.number;
      //alert(this.ProviderName);
    })
  }
  SelectExternalDoctor() {
    const modalRef = this.modalService.open(NgbSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
      modalRef.componentInstance.IsShowDoctor = false;
      modalRef.componentInstance.DoctorType = this.SelectedSource;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.ProviderName1 = receivedEntry.make;
      this.ProviderCode1 = receivedEntry.value;
        this.ProviderNumber1 = receivedEntry.number;      //alert(this.ProviderName);
        this.Institute = receivedEntry.Institute;
          this.CurrentSavePatientInfoRequest.RefCode = this.ProviderCode1;
      this.CurrentSavePatientInfoRequest.RefDetails = this.ProviderName1;
        this.CurrentSavePatientInfoRequest.RefContactNo = this.ProviderNumber1;
        this.CurrentSavePatientInfoRequest.RefInstitute = this.Institute;
    })
  }
  SelectStaff() {
    const modalRef = this.modalService.open(NgbSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
      modalRef.componentInstance.IsShowDoctor = true;
      modalRef.componentInstance.DoctorType = this.SelectedSource;
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.StaffName = receivedEntry.make;
      this.StaffCode = receivedEntry.value;
      this.StaffNumber = receivedEntry.number;
      //alert(this.ProviderName);
    })
  }
  SelectPatient() {
    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg'
      })
    modalRef.componentInstance.PATIENT_OBJ = true;
    modalRef.componentInstance.PATIENT_FORMATTED_CODE = false;
    modalRef.result.then((val: PatientInfoByFormattedCodeController) => {
      // alert(val.DisplayName);

      this.PatientActorCode = val.ActorCode;

      this.PatientName = val.DisplayName;
      this.PatientNumber = val.Telephone1;
      //  this.SaveAppt_SelectedPatient();
      //modalRef.result.
      ////alert(val);
      //const modalRef = this.modalService.open(NgbCounsellingRegistryModal,
      //    {
      //        centered: true,
      //        size: 'lg'
      //    })
      //modalRef.componentInstance.FormattedCode = val;
      //modalRef.result.then(x => { this.GetCounsellingPlanController() })
    });
  }
  //OpenCamera() {
  //    const modalRef = this.modalService.open(NgbCameraUploadModal,
  //     {
  //          centered: true

  //      })
  //}
  SelectPrimaryDoctor() {
    this.PrimaryDoctorO = false;
    this.PrimaryDoctorn = true;
    const modalRef = this.modalService.open(NgbSearchProviderModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
      modalRef.componentInstance.IsShowDoctor = true;
      modalRef.componentInstance.DoctorType = 'All';
    modalRef.componentInstance.passEntry.subscribe((receivedEntry) => {
      this.PrimaryDoctor = receivedEntry.make;
      this.PrimaryCode = receivedEntry.value;
      this.PrimaryNumber = receivedEntry.number;
      this.CurrentSavePatientInfoRequest.PrimaryDoctor = this.PrimaryDoctor;
      //alert(this.ProviderName);
    })
  }
  criteriaChange(value: string) {
        this.RefreshPatients(value);


    }
  ClearInput() {
        this.searchValue = '';
        // this.searchValue = null;
        //var searchtext = '';
        this.RefreshPatients(this.searchValue);
    }


}
